import * as React from 'react';
import { TextInput } from '@leagueplatform/genesis-core';
import type { ControlComponent } from '@web-config-app/entity-form';
import { EntityFormControl } from '@web-config-app/entity-form';

export const DateInputControl: ControlComponent = (props) => (
  <EntityFormControl
    {...props}
    renderControl={({
      data,
      handleChange,
      path,
      inputStatus,
      enabled,
      required,
    }) => (
      <TextInput
        type="date"
        value={data ?? ''}
        readOnly={!enabled}
        required={required}
        clearable={enabled && data && data.length > 0}
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
          const { value } = evt.currentTarget;
          if (value.trim().length < 1) {
            handleChange(path, undefined);
            return;
          }
          handleChange(path, value);
        }}
        onClear={() => handleChange(path, undefined)}
        inputStatus={inputStatus}
        css={{
          backgroundColor: '$inputBackgroundDefault',
        }}
      />
    )}
  />
);
